<script setup>
import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
  fromDateName: {
    type: String,
    default: 'createdAt',
  },
  toDateName: {
    type: String,
    default: 'createdAtEnd',
  },
})

const emit = defineEmits(['set-date'])

const { t } = useI18n()
const fromDate = ref('')
const toDate = ref('')
const fromRef = ref(null)
const toRef = ref(null)

const onClickCalendar = (ref) => {
  if (ref?.value) {
    $(ref.value).datepicker('show')
  }
}

const prepareDateForFilter = (dateString) => {
  if (!dateString) return null
  const dateParts = dateString.split('/')
  const date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
  return date.toISOString()
}

const setupDatepicker = (refElement, isFromDate) => {
  if (!refElement.value) return
  $(refElement.value)
    .datepicker({ format: 'dd/mm/yyyy', language: 'en' })
    .on('changeDate', () => {
      if (isFromDate) {
        fromDate.value = refElement.value.value
      } else {
        toDate.value = refElement.value.value
      }
    })
}

watch(fromDate, () => {
  emit('set-date', prepareDateForFilter(fromDate.value), prepareDateForFilter(toDate.value))
})

watch(toDate, () => {
  emit('set-date', prepareDateForFilter(fromDate.value), prepareDateForFilter(toDate.value))
})

onMounted(() => {
  setupDatepicker(fromRef, true)
  setupDatepicker(toRef, false)
})
</script>

<template>
  <div class="col-md-3">
    <div class="my-2">
      <label :for="fromDateName" class="fs-16 form-label-font">
        {{ t('contract.information.calendarAt') }}
      </label>
      <div class="input-group" @click="onClickCalendar(fromRef)">
        <input ref="fromRef" v-model="fromDate" type="text" class="form-control" />
        <div class="input-group-append">
          <span id="basic-addon2"><i class="fa fa-calendar"></i></span>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="my-2">
      <label :for="toDateName" class="fs-16 form-label-font">
        {{ t('contract.information.calendarAtEnd') }}
      </label>
      <div class="input-group" @click="onClickCalendar(toRef)">
        <input ref="toRef" v-model="toDate" type="text" class="form-control" />
        <div class="input-group-append">
          <span id="basic-addon2"><i class="fa fa-calendar"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>
